import { render, staticRenderFns } from "./ManagersComponent.vue?vue&type=template&id=02e3319e&"
import script from "./ManagersComponent.vue?vue&type=script&lang=js&"
export * from "./ManagersComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports